export const stats = [
  { value: '9', label: 'Volumes Complets' },
  { value: '500+', label: 'Pages de Ressources' },
  { value: '100+', label: 'Activités Extra' },
  { value: '100%', label: 'Prêt pour la Classe' },
]

export const beforeItems = [
  'Passer ses dimanches à chercher désespérément des idées sur Pinterest.',
  'Des photocopies vieillottes qui ne stimulent personne.',
  "L'angoisse de la « dernière minute » avant d'entrer en classe.",
  'La bureaucratie infinie et les grilles d’évaluation créées à minuit.',
  'Se sentir « le prof du petit dessin » aux yeux des parents et collègues.',
]

export const afterItems = [
  'Une année entière cartographiée mois par mois, du CP à la 3ème.',
  'Leçons visuelles à haut impact prêtes pour votre TNI/VPI.',
  'Un parcours logique et professionnel qui grandit avec vos élèves.',
  'Évaluation rapide : notes prêtes en 5 minutes avec des critères objectifs.',
  'Plus de temps pour vous, plus de respect pour votre matière et plus de joie en classe.',
]

export type Volume = {
  grade: string
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    grade: 'CP',
    title: 'L’Éveil des Sens et des Formes',
    text: 'Couleurs primaires, signes et découverte sensorielle.',
  },
  {
    grade: 'CE1',
    title: 'Matières, Textures et Collages',
    text: 'Les grands maîtres et la magie de la tridimensionnalité.',
  },
  {
    grade: 'CE2',
    title: 'L’Univers des Couleurs et de l’Espace',
    text: 'De la roue chromatique à la profondeur spatiale.',
  },
  {
    grade: 'CM1',
    title: 'Voyage dans l’Histoire de l’Art',
    text: 'De la Préhistoire au monde antique avec ateliers pratiques.',
  },
  {
    grade: 'CM2',
    title: 'Art Contemporain et Grands Maîtres',
    text: 'Les avant-gardes et la préparation au collège.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    grade: '6ème',
    title: 'Le Langage Visuel et la Géométrie',
    text: "Composition, symétrie et bases de l'analyse d'œuvre.",
  },
  {
    grade: '5ème',
    title: 'Image, Publicité et Message',
    text: 'Analyse critique des images et communication visuelle.',
  },
  {
    grade: '4ème',
    title: 'L’Art de l’Illusion et Perspective',
    text: "Maîtriser l'espace, la 3D et le réalisme.",
  },
  {
    grade: '3ème',
    title: 'Art Moderne, Numérique et Société',
    text: "Du cubisme au Street Art, prêt pour l'épreuve du Brevet.",
  },
]

export const bonuses = [
  {
    title: 'Le Kit « Atelier Zéro Chaos »',
    value: '17 €',
    text: 'Le système ultime pour organiser votre salle d’art et gérer le matériel sans stress.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/94434164-3095-4ee4-aab1-195044eab800.jpg',
  },
  {
    title: 'Fiches d’Évaluation Express',
    value: '14 €',
    text: 'Des grilles professionnelles et rubriques prêtes pour justifier chaque note avec des critères objectifs.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a1e06ce3-4799-4c43-aef9-8f63f63b3119.jpg',
  },
  {
    title: 'Le Musée à l’École',
    value: '9 €',
    text: 'Transformez votre classe en musée numérique. Apprenez à utiliser le TNI pour une expérience immersive.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/7734c95f-6fa8-4632-bdc2-5101e78bd69c.jpg',
  },
  {
    title: 'Art-Thérapie & Besoins Particuliers',
    value: '17 €',
    text: 'Stratégies pratiques pour une classe inclusive (DYS, EBEP). Ne laissez aucun élève de côté.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ea5b8771-0f61-42a5-be81-1525b1c8e797.jpg',
  },
  {
    title: 'Guide « Petit Budget »',
    value: '19 €',
    text: 'Comment réaliser des projets incroyables avec des matériaux de récupération et un budget limité.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/191a82e1-030b-4124-a281-f6e91b7c6297.jpg',
  },
]

export const offerRows = [
  { label: 'Pack ARTS PRÊT™ (9 Volumes)', value: '197 €' },
  { label: '5 Bonus Stratégiques', value: '76 €' },
]

export const testimonials = [
  {
    quote:
      "La programmation annuelle déjà faite m'a sauvé la rentrée. Enfin les élèves suivent les leçons sur le TNI sans s'ennuyer.",
    name: 'Claire L.',
    role: 'Professeure des Écoles (Primaire)',
  },
  {
    quote:
      "Un matériel d'une qualité rare. Le kit sur l'évaluation m'a enlevé un poids énorme face aux parents d'élèves.",
    name: 'Stéphane M.',
    role: 'Enseignant d’Arts Plastiques (Collège)',
  },
]

export const faqs = [
  {
    q: 'Quel est le format des ressources ?',
    a: 'Des PDF haute résolution, compatibles PC, Mac et tablette, prêts à imprimer ou à projeter.',
  },
  {
    q: 'Est-ce adapté aux non-spécialistes ?',
    a: 'Oui, chaque séance est guidée pas à pas, avec les objectifs et le matériel déjà indiqués.',
  },
  {
    q: 'Comment vais-je recevoir le pack ?',
    a: 'Lien de téléchargement immédiat par email après le paiement.',
  },
]

export const heroGuarantees = [
  'Téléchargement numérique instantané',
  'PDF prêts à imprimer',
  'Paiement unique',
]

export const footerLinks = [
  'Mentions Légales',
  'Politique de Confidentialité',
  'Contact',
]
